import { rolePermissions } from "../../utility/constants";
import Authorization from "../../utility/authorization";
// get auth user role
Authorization.setAuthUser();
const roleId = Authorization.getAuthRoleId();
// cehck permission is in constant
function isAllowed(type) {
  const roleObj = rolePermissions.find(role => role.roleId === roleId);
  type = type.split(".");
  if (roleObj) {
    const permissions = roleObj.permissions[type[0]];
    return permissions.includes(type[1]);
  } else return false;
}

/**
 * Function to return children based on access
 * @param {*} param0 section => String / Array of string
 * ie. "bookings.create" or ["bookings.create", "bookings.view"]
 */
export default function({ children, section }) {
  let allowed = false;
  if (Array.isArray(section)) {
    section.forEach(sec => {
      if (isAllowed(sec)) {
        allowed = true;
        return;
      }
    });
  } else {
    allowed = isAllowed(section);
  }
  return allowed ? children : null;
}
